import { DigitalVisitReasonEnum } from '@src/lib/__generated/api';
import { dataLayerReasonSelected } from '@src/services/dataLayerReasonSelected';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
interface UseReasonForVisitAnalyticsProps {
  reasonForVisitFromUrl?: DigitalVisitReasonEnum | null;
  isMottoFlow: boolean;
  facilityCode?: string;
  facilityName?: string;
}
export const useReasonForVisitFromUrlAnalytics = ({
  reasonForVisitFromUrl,
  isMottoFlow,
  facilityCode,
  facilityName
}: UseReasonForVisitAnalyticsProps) => {
  const router = useRouter();
  const {
    locale
  } = router;
  const hasLoggedRef = useRef(false);
  useEffect(() => {
    if (reasonForVisitFromUrl && !hasLoggedRef.current) {
      hasLoggedRef.current = true;
      dataLayerReasonSelected({
        reasonForVisit: reasonForVisitFromUrl,
        locale: locale,
        mottoFlow: isMottoFlow,
        facilityCode,
        facilityName
      });
    }
  }, [reasonForVisitFromUrl, isMottoFlow, facilityCode, facilityName, locale]);
};